import { Component, inject } from '@angular/core';
import { RoadActivityParameterService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RoadActivityParameterCreateDto,
  RoadActivityParameterDto,
  RoadActivityParameterExcelDownloadDto,
  RoadActivityParameterUpdateDto,
} from '../proxy/controlling/dtos/road-activity-parameter';
import { ROADACTIVITYPARAMETER_CONFIG, ROADACTIVITYPARAMETER_FIELDS } from './road-activity-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-road-activity-parameter',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RoadActivityParameterService, ConfirmationService],
  templateUrl: './road-activity-parameter.html',
  styleUrl: './road-activity-parameter.scss',
})
export class RoadActivityParameter extends BaseHierarchicalCrudComponent<
  RoadActivityParameterDto,
  RoadActivityParameterCreateDto,
  RoadActivityParameterUpdateDto,
  RoadActivityParameterExcelDownloadDto
> {
  service = inject(RoadActivityParameterService);
  config = ROADACTIVITYPARAMETER_CONFIG;
  fields = ROADACTIVITYPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: RoadActivityParameterDto): RoadActivityParameterUpdateDto {
    return {
      isVisibleFromMobile: data.isVisibleFromMobile,
      isMaterial: data.isMaterial,
      quarryTypeId: data.quarryTypeId,
      roadDistanceId: data.roadDistanceId,
      roadCargoTypeId: data.roadCargoTypeId,
      scopeTypeId: data.scopeTypeId,
      stageId: data.stageId,
      wbsId: data.wbsId,
      activityProcessParametrizationId: data.activityProcessParametrizationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RoadActivityParameter';
  }
}
